import { useStyletron } from 'baseui';

import { hexToRgb } from 'shared/helpers';

interface IENGTStatusIconProps {
	fillColorForImage: string;
	fillColorForText: string;
	label: string;
}

function ENGTStatusIcon({ fillColorForImage, fillColorForText, label }: IENGTStatusIconProps) {
	const [css]: [any, any] = useStyletron();

	return (
		<div
			className={css({
				alignItems: 'center',
				background: hexToRgb(fillColorForImage, 0.2),
				borderRadius: '0.25rem',
				color: fillColorForText,
				display: 'inline-flex',
				fontSize: '0.5625rem',
				fontWeight: 500,
				justifyContent: 'center',
				lineHeight: '0.6875rem',
				minHeight: '1.25rem',
				padding: '0 0.4rem',
				whiteSpace: 'nowrap',
				width: 'fit-content',
			})}
		>
			{label}
		</div>
	);
}

export default ENGTStatusIcon;
